<template>
	<div class="stage-card" :class="cardClass">
		<div class="stage-header" :class="headerClass">
			<div v-show="sortable" class="sort">
				<i class="fal fa-sort"></i>
			</div>
			<div class="title">{{ title }}</div>
			<div v-show="!noPermissions" class="permissions">
				<div class="permission entry" :class="entryClass">E</div>
				<div class="permission exit" :class="exitClass">S</div>
			</div>
			<div class="buttons">
				<div class="edit" @click="editEvent" v-if="!$mx_userIsCollaborator">
					<i class="fal fa-cog"></i>
				</div>
			</div>
			<div class="toggle" @click="toogleCard">
				<i :class="iconClass"></i>
			</div>
		</div>
		<div v-show="card.open" class="stage-body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	import { permissionsMixin } from '@/mixins'

	export default {
		name: 'stage-card',

		mixins: [permissionsMixin],

		props: {
			/**
			 * Propriedade: title
			 * Recebe o título do componente.
			 */
			title: {
				type: String,
				required: true,
			},

			/**
			 * Propriedade: objectData
			 * Recebe um objeto que será retornado nos eventos.
			 */
			objectData: {
				type: Object,
				required: true,
			},

			/**
			 * Propriedade: sortable
			 * Define se o componente terá design de ordenável.
			 */
			sortable: {
				type: Boolean,
				default: false,
			},

			/**
			 * Propriedades: entry, exit
			 * Define se há permissão de entrada e saida.
			 */
			entry: {
				type: Boolean,
				default: false,
			},

			exit: {
				type: Boolean,
				default: false,
			},

			/**
			 * Propriedades: noPermissions
			 * Desativa os icones de permissão.
			 */

			noPermissions: {
				type: Boolean,
				default: false,
			},

			/**
			 * Propriedades modificadoras de estilo.
			 */

			/**
			 * Propriedades: mbOff
			 * Desativa a margin-bottom do componente.
			 */
			mbOff: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				card: {
					open: false,
				},
			}
		},

		computed: {
			cardClass() {
				return {
					'mb-off': this.mbOff,
				}
			},

			entryClass() {
				return [this.entry ? 'active' : 'block']
			},

			exitClass() {
				return [this.exit ? 'active' : 'block']
			},

			headerClass() {
				return {
					closed: !this.card.open,
				}
			},

			iconClass() {
				return [this.card.open ? 'fas fa-caret-up' : 'fas fa-caret-down']
			},
		},

		methods: {
			editEvent() {
				if (this.$mx_userIsCollaborator) return
				
				this.$emit('stage-card-edit', this.objectData)
			},

			toogleCard() {
				this.card.open = !this.card.open
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
